import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { OrderGuideInfoParLevelTable } from './order-guide-info-par-level-table';
import { Text } from 'react-native';
import { useOrderGuideItemsContext } from '@/contexts/order-guide-items-context';

interface ParLevelProps {
  orderGuidePartitionUUID?: string;
  variantPackUUID: string;
}

export const ParLevel = ({
  variantPackUUID,
  orderGuidePartitionUUID,
}: ParLevelProps) => {
  const { variantPackPartitionMap, selectedCollection } =
    useOrderGuideItemsContext();
  const [styles] = useStyles();

  const parLevelElement = useMemo(() => {
    const partitionMap = variantPackPartitionMap[variantPackUUID];

    if (!partitionMap) {
      return null;
    }

    if (!orderGuidePartitionUUID) {
      const partitionParLevels = (selectedCollection?.partitions || []).reduce<
        [string, number][]
      >((acc, partition) => {
        const parLevel =
          partitionMap[partition.uuid]?.order_guide_restaurant?.par_level;
        if (typeof parLevel === 'number') {
          acc.push([partition.name, parLevel]);
        }

        return acc;
      }, []);

      if (partitionParLevels.length === 0) {
        return null;
      }

      return (
        <OrderGuideInfoParLevelTable partitionParLevels={partitionParLevels} />
      );
    }

    const parLevel =
      partitionMap[orderGuidePartitionUUID]?.order_guide_restaurant?.par_level;

    return typeof parLevel === 'number' ? (
      <Text
        style={[TYPOGRAPHY.xsmall, FONTS.primarySemiBold, styles.textColor]} // parLevelTextStyle
      >
        {i18n.t('par_level', { number: parLevel })}
      </Text>
    ) : null;
  }, [
    orderGuidePartitionUUID,
    selectedCollection,
    variantPackPartitionMap,
    variantPackUUID,
    styles,
  ]);

  return parLevelElement;
};

const useStyles = createStyles((theme) => ({
  textColor: {
    color: theme.colors.inactiveText,
    fontFamily: theme.fonts.primary,
  },
}));
